<template>
  <!-- <div id="app" :style="`height:${screenHeight}`"> -->
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { getRandomString } from '@/utils'

  export default {
    data() {
      return {
        screenHeight: '100vh',
        clientHeight: ''
      }
    },
    mounted() {
      let _this = this
      window.addEventListener('resize', function() {
        // _this.screenHeight = window.innerHeight + 'px'; 
        var vh = window.innerHeight;
        // document.body.style.height = window.innerHeight + 'px'; 
        console.log('窗口变化', _this.screenHeight)
        // document.documentElement.style.height = vh + 'px';
        // _this.$refs.app.style.height = vh + 'px';
      }, false);
      window.addEventListener('keyboardWillShow', this.keyboardWillShow);
      this.getUserChatToken()
    },

    methods: {
      keyboardWillShow(e){
        this.$message.error('键盘弹出')
        let keyboardHeight = e.keyboardHeight;
        // document.body.style.marginBottom = `-${keyboardHeight}px`;
        // document.body.style.marginBottom = `-200px`;
      },
      getUserChatToken() {
        let randomStr = getRandomString()
        console.log('randomStr',randomStr)
        
        this.$store.commit('SET_USER_CHART_TOKEN', randomStr)
      }
    },
  }
</script>

<style lang="scss">
#app {
  width: 100vw;
  height: 100vh;
  // background: linear-gradient(to bottom right, #b8c9f8, #dcdcf8, #eaeef6)

  // overflow: hidden;
  // -webkit-overflow-scrolling: touch
}

</style>
